<span
  class="inputSwitchlabel"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.inputSelector]="'.input-switch-label p'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.display]="displayCss">
  <iu-checkbox-ui
    [attr.data-cy]="isTriState ? 'input-switch-tri' : 'input-switch'"
    [attr.data-cy-columnName]="data ? data.columnName : columnName"
    [attr.data-cy-value]="checked"
    [disabled]="isReadOnly"
    [ngClass]="{ 'iu-field-conflict': hasConflict }"
    [tristate]="isTriState"
    [(checked)]="checked"
    (contextmenu)="onContextMenu($event)"
    (press)="onContextMenu($any($event))" />
  @if (this.isLabelDisplay) {
    <span
      #spanRef
      class="input-switch-label"
      style="height: 100%"
      [ngClass]="[hasConflict ? 'iu-field-conflict-icon' : '']"
      (contextmenu)="onContextMenu($event)"
      (press)="onContextMenu($any($event))">
      <p style="width: fit-content" (click)="!isReadOnly && labelClick($event)">{{ label }}</p>
      @if (hasConflict && dataStored) {
        <i
          #spanInput
          role="button"
          tabindex="0"
          [attr.title]="opConflict.iconTooltip"
          [attr.aria-label]="opConflict.iconTooltip"
          class="rtconflict fas fa-exclamation-triangle iconClass iu-field-conflict-icon"
          style="float: none"
          (click)="showConflictPanel($event)"
          (keydown.enter)="showConflictPanel($event)"
          (keydown.space)="showConflictPanel($event)">
        </i>
      }
    </span>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-field-conflict-panel #opConflict [field]="this" />
